import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import store from './redux/store';
import MainApp from './container/MainApp';
import { NotificationContainer } from 'react-notifications';
//import OneSignal from 'react-onesignal';

import './assets/css/custom.css';
import './assets/css/mobile-forms.css';
import 'react-notifications/lib/notifications.css';
//import "react-big-calendar/lib/css/react-big-calendar.css";
// locale
import moment from 'moment';
import Wrapper from './lang';
import en_US from './lang/locales/en_US';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'moment-timezone';
import { GoogleTranslateProvider } from './providers/GoogleTranslateProvider';

// moment.locale('vi');
moment.locale('en');
// dayjs.locale('en')
moment.tz.setDefault('Asia/Bangkok');
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});



export default class App extends Component {
  constructor(props) {
    super(props);
    this.isOneSignalInitialized = false;
  }

  render() {
    return (
      // store
      <Provider store={store}>
        <ConfigProvider
          locale={en_US}
          theme={{
            token: {
              colorPrimary: '#0A3150',
              borderRadiusBase: '2px',
            },
            components: {
              Switch: {
                colorPrimary: '#00b96b',
              },
            },
          }}
        >
          <BrowserRouter>
            <Wrapper>
              <GoogleTranslateProvider>
                <QueryClientProvider client={queryClient}>
                  <MainApp />
                </QueryClientProvider>
              </GoogleTranslateProvider>
            </Wrapper>
            <NotificationContainer />
          </BrowserRouter>
        </ConfigProvider>
      </Provider>
    );
  }
}
